module.exports = __webpack_public_path__ + "img/mq.4de172f5.svg";